/* eslint-disable no-control-regex */
/* eslint-disable no-useless-escape */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-undef */
/* eslint-disable one-var */
/* eslint-disable no-plusplus */
/* eslint-disable prefer-const */
/* eslint-disable no-unused-expressions */
/* eslint-disable default-case */
/* eslint-disable object-shorthand */

import axios from 'axios';
import Vue from 'vue';
import globals from '../../common/globals';
import vxSpinner from '../../common/vx-spinner/vx-spinner.vue';
import AnalyticsService from '../../common/services/analytics-service';
// import AgilOneMixin from '../../common/mixins/agilone-mixin';
import tableToForm from '../../common/mixins/tableToForm-mixin';
import cookiesMixin from '../../common/mixins/cookies-mixin'
import brawnyGTA from '../../../brawny/components/brawny-gta/brawny-gta.vue';
import contentStack from '../contentstack/vx-contentstack/vx-contentstack.vue';
import csArticle from '../contentstack/cs-article/cs-article.vue';
import vxMysteryReferral from '../../../marketingpages/components/vx-mystery-referral/vx-mystery-referral.vue';
import vxMysteryOverview from '../../../marketingpages/components/vx-mystery-overview/vx-mystery-overview.vue';
import vxMysteryOptIn from '../../../marketingpages/components/vx-mystery-offer-opt-in/vx-mystery-offer-opt-in.vue';
import vxMysteryOptInThankYou from '../../../marketingpages/components/vx-mystery-opt-in-thank-you/vx-mystery-opt-in-thank-you.vue';
import vxMysteryReferralThankYou from '../../../marketingpages/components/vx-mystery-referral-thank-you/vx-mystery-referral-thank-you.vue';

import vxCampaignOurBelief from '../../../components/campaigns/vx-campaign-our-belief/vx-campaign-our-belief.vue';
import vxCampaignNonimate from '../../../components/campaigns/vx-campaign-nominate/vx-campaign-nominate.vue';
import vxCampaignProgram from '../../../components/campaigns/vx-campaign-program/vx-campaign-program.vue';
import vxCampaignVolunteerMatch from '../../../components/campaigns/vx-campaign-volunteer-match/vx-campaign-volunteer-match.vue';
import vxCampaignGiants from '../../../components/campaigns/vx-campaign-giants/vx-campaign-giants.vue';
import vxCampaignBrawnyTakesAction from '../../../components/campaigns/vx-campaign-brawny-takes-action/vx-campaign-brawny-takes-action.vue';
import vxCampaignConnect from '../../../components/campaigns/vx-campaign-connect/vx-campaign-connect.vue';
import vxCampaignFixedMenu from '../../../components/campaigns/vx-campaign-fixed-menu/vx-campaign-fixed-menu.vue';
import vxInteractiveMap from '../../../quilted-northern/components/vx-interactive-map/vx-interactive-map.vue';
import vxMarketingAddToCart from '../vx-marketing-add-to-cart/vx-marketing-add-to-cart.vue';
import vxPageLinks from '../../../marketingpages/components/vx-pagelinks/vx-pagelinks.vue';

// import externalComponent from '../../common/mixins/external-component-mixin';

// const brawnyGTA = () => externalComponent('https://d2o3o2wreiygww.cloudfront.net/y/stg/ext/shared/brawny-gta/brawny-gta.c2bb2dc67417c3eb3d29.umd.min.js');
// Child
// const myComponent = () => externalComponent('https://d2o3o2wreiygww.cloudfront.net/y/stg/ext/shared/MyComponent/MyComponent.8c20b2b8fbe3f022c58e.umd.min.js');
// const myComponent = () => externalComponent('https://d2o3o2wreiygww.cloudfront.net/y/stg/ext/shared/MyComponent/MyComponent.9c089f2fd67755a3ca8e.umd.min.js');

export default {
  name: 'vx-marketing-form',
  components: {
    vxSpinner,
  },
  props: {
    content: {
      type: String,
    },
    component: {
      required: true,
      type: Object,
    },
    props: {
      default: () => ({}),
      type: Object,
    },
  },
  mixins: [tableToForm, cookiesMixin], // AgilOneMixin
  created: function() {
    const util = {
      parseQueryString: () => {
        if (window.location.search.length > 0) {
          const q = window.location.search.substring(1).split('&');
          if (q) {
            for (let i = 0; i < q.length; i++) {
              let P = q[i].split('='),
                key = decodeURIComponent(P[0]),
                value = decodeURIComponent(P[1]);
              this.queryString[key.toLowerCase()] = value;
            }
          }
        }
      },
      applyQueryStringToConfig: () => {
        for (const prop in this.config) {
          if (this.queryString[prop.toLowerCase()]) {
            this.config[prop] = this.queryString[prop.toLowerCase()];
          }
        }
      },
    };
    util.parseQueryString();
    util.applyQueryStringToConfig();
  },
  render: function(createElement) {
    const self = this;
    return (function(cEl, content) {
      const util = {
        hasSpinner: false,
        populate: () => {
          let formObj = document
            .createRange()
            .createContextualFragment(decodeURIComponent(content));
          let ret = {};
          if (formObj.firstChild) {
            const kids = util.parseChildren(formObj);

            if (kids && kids.length > 0) {
              if ((!util.hasSpinner)) {
                kids.push(cEl(vxSpinner, { ref: 'spinner', props: { id: 'spinner', image: `${self.globals.assetsPath}images/spinner.gif`, fullscreen: '' } }));
              }
              ret = cEl('div', kids);
            } else {
              ret = cEl('div', 'Parse children failed');
            }
          }
          return ret;
        },
        compile: (el) => {
          try {
            try {
              let templateText = el.innerHTML;
              const result = Vue.compile(
                templateText.replace(/\s{2,}/g, ''),
              );
              return result.render;
              // return {
              //   render: this.formatFunction(result.render),
              //   staticRenderFns: result.staticRenderFns.map(this.formatFunction),
              // };
            } catch (error) {
              return error.message;
            }
          } catch (e) {
            console.log(e);
            return cEl('div', [`parse: ${e.message}`]);
          }
        },
        parse: (el) => {
          try {
            /* Moved the vx- tag processing above children so that Vue can parse the children instead */
            if (el.tagName === 'BRAWNY-GTA') {
              try {
                let props = {};
                props.campaignData = JSON.parse(el.innerText);
                // console.log('window[MyComponent.9c089f2fd67755a3ca8e]', window['MyComponent.9c089f2fd67755a3ca8e'], window['MyComponent.9c089f2fd67755a3ca8e'] === brawnyGTA);
                // console.log('window[brawny-gta.c2bb2dc67417c3eb3d29]', window['brawny-gta.c2bb2dc67417c3eb3d29'], window['brawny-gta.c2bb2dc67417c3eb3d29'] === brawnyGTA);
                return cEl(brawnyGTA, { props });
              } catch (e) {
                return cEl('div', [`parse: ${e.message}`]);
              }
            }
            // Brawny GTA Components
            if (el.tagName === 'VX-CAMPAIGN-OUR-BELIEF') {
              try {
                let props = {};
                props.ourBelief = JSON.parse(el.getAttribute(':ourbelief'));
                return cEl(vxCampaignOurBelief, { props });
              } catch (e) {
                return cEl('div', [`parse: ${e.message}`]);
              }
            }
            if (el.tagName === 'VX-CAMPAIGN-NOMINATE') {
              try {
                let props = {};
                props.nominate = JSON.parse(el.getAttribute(':nominate'));
                return cEl(vxCampaignNonimate, { props });
              } catch (e) {
                return cEl('div', [`parse: ${e.message}`]);
              }
            }
            if (el.tagName === 'VX-CAMPAIGN-PROGRAM') {
              try {
                let props = {};
                props.theProgram = JSON.parse(el.getAttribute(':theProgram'));
                return cEl(vxCampaignProgram, { props });
              } catch (e) {
                return cEl('div', [`parse: ${e.message}`]);
              }
            }
            if (el.tagName === 'VX-CAMPAIGN-VOLUNTEER-MATCH') {
              try {
                let props = {};
                return cEl(vxCampaignVolunteerMatch, { props });
              } catch (e) {
                return cEl('div', [`parse: ${e.message}`]);
              }
            }
            if (el.tagName === 'VX-CAMPAIGN-GIANTS') {
              try {
                let props = {};
                props.slideData = JSON.parse(el.getAttribute(':slide-data'));
                return cEl(vxCampaignGiants, { props });
              } catch (e) {
                return cEl('div', [`parse: ${e.message}`]);
              }
            }
            if (el.tagName === 'VX-CAMPAIGN-BRAWNY-TAKES-ACTION') {
              try {
                let props = {};
                props.slideDataBta = JSON.parse(el.getAttribute(':slide-data-bta'));
                return cEl(vxCampaignBrawnyTakesAction, { props });
              } catch (e) {
                return cEl('div', [`parse: ${e.message}`]);
              }
            }
            if (el.tagName === 'VX-CAMPAIGN-CONNECT') {
              try {
                let props = {};
                return cEl(vxCampaignConnect, { props });
              } catch (e) {
                return cEl('div', [`parse: ${e.message}`]);
              }
            }
            if (el.tagName === 'VX-CAMPAIGN-FIXED-MENU') {
              try {
                let props = {};
                props.menus = JSON.parse(el.getAttribute(':menus'));
                return cEl(vxCampaignFixedMenu, { props });
              } catch (e) {
                return cEl('div', [`parse: ${e.message}`]);
              }
            }
            if (el.tagName === 'VX-MYSTERY-REFERRAL') {
              try {
                let props = {};
                return cEl(vxMysteryReferral, { props });
              } catch (e) {
                return cEl('div', [`parse: ${e.message}`]);
              }
            }
            if (el.tagName === 'VX-MYSTERY-REFERRAL-THANK-YOU') {
              try {
                let props = {};
                return cEl(vxMysteryReferralThankYou, { props });
              } catch (e) {
                return cEl('div', [`parse: ${e.message}`]);
              }
            }
            if (el.tagName === 'VX-MYSTERY-OVERVIEW') {
              try {
                let props = {};
                return cEl(vxMysteryOverview, { props });
              } catch (e) {
                return cEl('div', [`parse: ${e.message}`]);
              }
            }
            if (el.tagName === 'VX-MYSTERY-OPT-IN') {
              try {
                let props = {};
                return cEl(vxMysteryOptIn, { props });
              } catch (e) {
                return cEl('div', [`parse: ${e.message}`]);
              }
            }
            if (el.tagName === 'VX-MYSTERY-OPT-IN-THANK-YOU') {
              try {
                let props = {};
                return cEl(vxMysteryOptInThankYou, { props });
              } catch (e) {
                return cEl('div', [`parse: ${e.message}`]);
              }
            }
            if (el.tagName === 'VX-INTERACTIVE-MAP') {
              try {
                let props = {};
                return cEl(vxInteractiveMap, { props });
              } catch (e) {
                return cEl('div', [`parse: ${e.message}`]);
              }
            }
            if (el.tagName === 'VX-PAGELINKS') {
              try {
                let props = {};
                return cEl(vxPageLinks, { props });
              } catch (e) {
                return cEl('div', [`parse: ${e.message}`]);
              }
            }

            const attrs = util.parseAttributes(el);
            const domProps = util.parseDomProps(el);
            const on = util.parseHandlers(el, attrs);

            /* Process children for other tag types */
            const children = util.parseChildren(el, cEl);

            if (el.tagName === 'VX-CONTENTSTACK') {
              try {
                const props = { contententryid: attrs.contententryid };
                return cEl(contentStack, { props });
              } catch (e) {
                return cEl('div', [`parse: ${e.message}`]);
              }
            }
            // vxMarketingAddToCart
            if (el.tagName === 'VX-MARKETING-ADD-TO-CART') {
              try {
                const props = { behavior: attrs.behavior, sku: attrs.sku, quantity: attrs.quantity, buttontext: attrs.buttontext, userTarget: attrs.target };
                return cEl(vxMarketingAddToCart, { props });
              } catch (e) {
                return cEl('div', [`parse: ${e.message}`]);
              }
            }

            if (el.tagName === 'CS-ARTICLE') {
              try {
                const props = { contententryid: attrs.contententryid };
                return cEl(csArticle, { props });
              } catch (e) {
                return cEl('div', [`parse: ${e.message}`]);
              }
            }
            let ref = null;
            if (el.hasAttribute('ref')) {
              ref = el.getAttribute('ref');
            }
            if (el.nodeName === '#text') {
              return el.nodeValue;
            }
            if (el.tagName === 'VX-SPINNER') {
              util.hasSpinner = true;
              return cEl(vxSpinner, { ref, attrs, domProps, on }, children);
            }

            return cEl(el.tagName, { ref, attrs, domProps, on }, children);
          } catch (e) {
            console.log(e);
            return cEl('div', [`parse: ${e.message}`]);
          }
        },
        parseChildren: (el) => {
          const ret = [];
          try {
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < el.childNodes.length; i++) {
              if (el.childNodes[i].nodeName && el.childNodes[i].nodeName.toLowerCase() === 'table' && util.hasClass(el.childNodes[i], 'GPformDef')) {
                let temp = self.ParseTable(el.childNodes[i]);
                console.log('temp', temp);
                ret.push(util.parse(temp, cEl)); // Don't need anything else from the table...
              } else if (el.childNodes[i].nodeName === '#text') {
                ret.push(el.childNodes[i].nodeValue);
              } else {
                ret.push(util.parse(el.childNodes[i], cEl));
              }
            }
          } catch (e) {
            console.log(e);
            return cEl('div', [`parseChildren: ${e.message}`]);
          }

          return ret;
        },
        produceVnode: (_vm, part1, part2) => {
          try {
            // debugger;
            // const func = new Function(`${vm}`, 'part1', 'part2', 'const ret = _vm._v(part1 + _vm._s(_vm.part1)); console.log(ret); return _ret;');
            const funcBody = `_vm._v("${part1}" + _vm._s(_vm.${part2}));`; // console.log("${part2}", ret); return _ret;`;
            console.log('funcBody', funcBody);
            // eslint-disable-next-line no-new-func
            const func = new Function(funcBody);
            return func.apply(self); // , [self, subParts[0], subParts[1]]);
          } catch (e) {
            console.log(e);
            console.log('e', e.message);
            return cEl('div', [`parseChildren: ${e.message}`]);
          }
        },
        parseHandlers: (el, attrs) => {
          const ret = {};
          try {
            const loweredTagName = el.tagName ? el.tagName.toLowerCase() : '';
            const classes = el.className ? el.className.split(' ') : [];
            const attrstype = attrs.type ? attrs.type.toLowerCase() : '';
            const attrsvalue = attrs.value ? attrs.value.toLowerCase() : '';
            const attrsname = attrs.name ? attrs.name.toLowerCase() : '';


            if (loweredTagName === 'button' && classes.indexOf('GPformButtonSubmit')) {
              ret.click = self.GPsubmitForm;
            } else if (loweredTagName === 'a' && classes.indexOf('close-btn popup-close')) {
              ret.click = self.hidePopup;
            } else if (loweredTagName === 'input') {
              // This may prove useful to connect the field to the model.
              // const self = this;
              // ret.input = (event) => {
              //   console.log('self.$emit', event);
              //   self.$emit('input', event.target.value);
              // };
              if (attrstype === 'radio') {
                ret.click = self.radioSelection;
              }

              if ((self.config.formBehavior.toLowerCase() === 'optin-popup' || self.config.formBehavior.toLowerCase() === 'optin') && attrstype === 'email' && attrsname && attrsname === 'email') {
                ret.click = self.emailInputClick;
              }

              if ((self.config.formBehavior.toLowerCase() === 'optin-popup' || self.config.formBehavior.toLowerCase() === 'optin') && attrstype === 'text' && attrsname && attrsname === 'zip') {
                ret.click = self.zipInputClick;
              }
              if (attrstype === 'submit' || attrsvalue === 'submit') {
                ret.click = self.GPsubmitForm;
                // } else if (attrstype === 'email') {
                //   util.emailField = el;
              } else {
                ret.change = (e) => {
                  if (e.which === 13) {
                    self.GPsubmitForm(e);
                  }
                };
              }
              if (attrs.validation) {
                ret.keyup = self.GPFieldValidate;
              }
            } else if (loweredTagName === 'textarea') {
              if (attrs.validation) {
                ret.keyup = self.GPFieldValidate;
              }
              // } else if (loweredTagName === 'select') {
              //   util.formCollection.push(el);
              //       ret.keyup = self.GPFieldValidate;
            }
            if (attrs.validation && (loweredTagName === 'select' || classes.indexOf('opt-in-checkbox'))) {
              ret.change = self.GPFieldValidate;
            }
          } catch (e) {
            console.log(e);
          }
          return ret;
        },
        checkForQueryString: (el) => {
          if (el.tagName.toLowerCase() === 'input' && el.hasAttribute('name')) {
            const inputName = el.getAttribute('name').toLowerCase();
            return self.queryString[inputName] ? self.queryString[inputName] : null;
          }
          return null;
        },
        checkAttribute: (attrValue) => {
          try {
            // eslint-disable-next-line no-new-func
            const func = new Function(`try{ return ${attrValue}; } catch (e) { return "${attrValue}"; }`);
            return func.apply(this);
          } catch (e) {
            console.log('checkAttribute error:', e);
            return attrValue;
          }
        },
        parseAttributes: (el) => {
          const ret = {};
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < el.attributes.length; i++) {
            if (el.attributes[i].name === 'ref') {
              // skipt this attrib
            } else if (el.attributes[i].name[0] === ':' || el.attributes[i].name.substring(0, 6) === 'v-bind:') {
              // eslint-disable-next-line no-new-func
              ret[el.attributes[i].name.substring(1)] = eval(`self.${el.attributes[i].value}`);
            } else {
              ret[el.attributes[i].name] = el.attributes[i].value;
              if (el.attributes[i].name.indexOf('data-') === 0) {
                util.checkForConfig(el.attributes[i]);
              }
            }
          }
          const qs = util.checkForQueryString(el);
          if (qs) {
            ret.value = qs;
          }
          return ret;
        },
        checkForConfig: function(attr) {
          const attrname = attr.name ? attr.name.toLowerCase() : '';
          switch (attrname) {
            case 'data-submiturl':
              self.config.submitUrl = attr.value;
              break;
            case 'data-thankstarget':
              self.config.thanksTarget = attr.value;
              break;
            case 'data-targettype':
              self.config.targetType = attr.value;
              break;
            case 'data-gallerytarget':
              self.config.galleryTarget = attr.value;
              break;
            case 'data-getoptinstatusurl':
              self.config.getoptinstatusUrl = attr.value;
              break;
            case 'data-intsource':
              self.config.intSource = attr.value;
              break;
            case 'data-formbehavior':
              self.config.formBehavior = attr.value;
              break;
            case 'data-popupdelay':
              self.config.popupdelay = attr.value;
              break;
            case 'data-precheckoptstatus':
              self.config.preCheckOptStatus = attr.value === 'true';
              break;
            case 'data-opt_attribution_version':
              self.config.opt_Attribution_Version = attr.value;
              break;
          }
        },
        parseDomProps: function(el) {
          // This is where you can add DomProps. Not sure what these are
          const ret = {};
          if (el.nodeName === '#text') {
            // ret.innerText = el.nodeValue;
          }
          return ret;
        },
        // added for support of ticket YCOM-13630
        addClass(el, className) {
          let classes = el.className ? el.className.split(' ') : [];
          if (classes.indexOf(className) === -1) {
            classes.push(className);
            // eslint-disable-next-line no-param-reassign
            el.className = classes.join(' ');
          }
        },
        hasClass(el, className) {
          let classes = el.className ? el.className.split(' ') : [];
          return classes.indexOf(className) > -1;
        },
        removeClass(el, className) {
          let classes = el.className ? el.className.split(' ') : [];
          const ret = [];
          for (let i = 0; i < classes.length; i++) {
            let e = classes[i];
            if (e !== className) {
              ret.push(e);
            }
          }
          // eslint-disable-next-line no-param-reassign
          el.className = ret.join(' ');
        },


      };

      return util.populate();
    })(createElement, this.content);
  },

  async mounted() {
    let siteName = this.globals.siteId === 'vanityfair' ? 'vanityfairnapkins' : this.globals.siteId;
    if (!siteName) { siteName = this.globals.siteId ? this.globals.siteId : 'marketingpages'; }
    if (this.config.submitUrl.length === 0) {
      switch (this.config.formBehavior.toLowerCase()) {
        case 'optin':
        case 'optin-popup':
          this.config.submitUrl = `/gpcommercewebservices/v2/${siteName}/utilityforms/explicitoptin`;
          break;
        case 'optout':
          this.config.submitUrl = `/gpcommercewebservices/v2/${siteName}/utilityforms/explicitoptout`;
          break;
      }
    }
    if (this.config.getoptinstatusUrl.length === 0) {
      this.config.getoptinstatusUrl = `/gpcommercewebservices/v2/${siteName}/utilityforms/getoptstatus`;
    }
    if (this.config.opt_Attribution_Version.length === 0) {
      this.config.opt_Attribution_Version = this.config.intSource;
    }

    if (this.$el && this.$el.querySelector) {
      try {
        this.emailField = this.$el.querySelector('input[type="email"]');
        this.gpFormErrorMsg = this.$el.querySelector('.GPformErrorMsg');
        this.submitButton = this.$el.querySelector('.GPformButtonSubmit');
        if (this.queryString.cpuserid && document.cookie.indexOf('cpUserId') === -1) {
          let CookieDate = new Date();
          CookieDate.setFullYear(CookieDate.getFullYear() + 10);
          document.cookie = `cpUserId=${this.queryString.cpuserid};expires=${CookieDate.toUTCString()}; path=/`;
        }

        if (this.config.formBehavior === 'optin-popup' && sessionStorage.getItem('popup') === null && document.cookie.indexOf('cpUserId') === -1) {
          // sessionStorage.setItem('popup', 'true');
          // Set a cookie with current date and time
          if (this.readCookie(this.globals.POPUP_TIME_FLAG) === null) {
            this.createCookie(this.globals.POPUP_TIME_FLAG, new Date());
          }
          const timeDiff = new Date() - new Date(this.readCookie(this.globals.POPUP_TIME_FLAG));

          if(!this.isFilteredPage()) {
            this.popupCloseButton = this.$el.parentElement.querySelector('.popup-close');
          this.popupBox = this.$el.parentElement.querySelector('.popup-box');
          this.popupWrap = this.$el.parentElement.querySelector('.popup-wrap');

          if(timeDiff < this.config.popupdelay || sessionStorage.getItem('popup') === null) {
            const remainingTime = this.config.popupdelay - timeDiff;
            setTimeout(this.showPopup, remainingTime);
          }
          }

        } else if (this.config.formBehavior === 'optin') {
          this.intervalID = setInterval(this.checkFormPos, 5000);
        }
      } catch (e) {
        console.log(e);
        console.log(`mounted: ${e.message}`);
      }
    }
  },
  data() {
    return {
      rendercount: 0,
      emailField: null,
      existingOpt: false,
      submitButton: {},
      queryString: {},
      gpFormErrorMsg: {},
      popupCloseButton: {},
      popupBox: {},
      popupWrap: {},
      analyticsService: new AnalyticsService(),
      globals,
      hasSpinner: false,
      popupEmailClicked: false,
      popupZipClicked: false,
      optinEmailClicked: false,
      optinZipClicked: false,
      findingSubmitErrors: false,
      successfulSubmit: false,
      intervalID: {},
      API_URL: '/gpcommercewebservices/v2/gppro/apiproxy',
      config: {
        formName: '.GPform',
        formBehavior:
          '' /* 'optout', 'passthru', 'optin-popup', 'optin-sticky' */,
        popupdelay: '',
        triggerType: 'click',
        trigger: '.fpdp-btn',
        enableBriteVerify: true /* false */,
        submitUrl: '',
        targetType: 'url',
        thanksTarget: '/save/paper-towel-coupons/thanks',
        galleryTarget: '/save/paper-towel-coupons/gallery?cpuserid=',
        optoutTarget: '/opt-out/success',
        passthruTarget: '' /* Target URL for pass thru forms */,
        getoptinstatusUrl: '',
        preCheckOptStatus: true,
        intSource: '',
        opt_Attribution_Version: '',
        debug: false,
        initialized: false,
        authUrl: '/authorizationserver/oauth/token?client_id=mobile_android&client_secret=secret&grant_type=client_credentials',
        urlPrefix: '',
        auth_token: '',
      },
    };
  },

  methods: {
    GPisValidEmailAddress() {
      let email = this.emailField.value;
      if (email.length <= 4) return false;

      if (email[0] === ':') email = email.substr(1);

      const pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
      return pattern.test(email);
    },
    DisableSubmit() {
      if (this.submitButton) {
        this.submitButton.setAttribute('disabled', true);
        this.submitButton.setAttribute('data-enabled-value', this.submitButton.getAttribute('value'));
        this.submitButton.setAttribute('value', 'WORKING...');
        if (this.$refs.spinner) {
          this.$refs.spinner.showSpinner();
        }
      }
    },
    EnableSubmit() {
      if (this.submitButton) {
        this.submitButton.removeAttribute('disabled');
        this.submitButton.setAttribute('value', this.submitButton.getAttribute('data-enabled-value'));
        this.submitButton.removeAttribute('data-enabled-value');
        if (this.$refs.spinner) {
          this.$refs.spinner.hideSpinner();
        }
      }
    },
    GPsubmitForm(e) {
      e.preventDefault();
      let brands = [this.globals.siteId];

      let errorCount = 0;
      const fields = this.$el.querySelectorAll('input, select, textarea');
      this.findingSubmitErrors = true;
      for (let i = 0; i < fields.length; i++) {
        const element = fields[i];
        errorCount += this.GPFieldValidate(element);

        let fieldName = element.getAttribute('name');
        fieldName = fieldName ? fieldName.toLowerCase() : '';
        if (fieldName === 'brands' && element.value) {
          brands = element.value.split(',');
        }
      }
      this.findingSubmitErrors = false;

      if (errorCount < 1) {
        this.DisableSubmit();
        // Define a method which will call BriteVerify from one the two steps below
        const callBriteVerify = () => {
          this.ValidateBriteVerify((success) => {
            if (success) {
              this.SendFormData();
            } else {
              this.emailField.setAttribute('data-error-msg', 'The value of the Email field is not valid');
              this.ShowErrors();
              this.EnableSubmit();
            }
          });
        };

        if (this.config.preCheckOptStatus) {
          this.GetUserOptInStatus((data) => {
            this.existingOpt = false;
            if (data.results.success) {
              if (data.results.opts.length > 0) {
                for (let i = 0; i < brands.length; i++) {
                  let brand = brands[i];
                  if (!this.existingOpt) {
                    for (let j = 0; j < data.results.opts.length; j++) {
                      this.existingOpt = brand.toLowerCase() === data.results.opts[j].brand.toLowerCase();
                    }
                  }
                }
              }
            }
            if (!this.existingOpt && this.config.enableBriteVerify) {
              callBriteVerify();
            } else {
              this.SendFormData();
            }
          });
        } else if (this.config.enableBriteVerify) {
          callBriteVerify();
        } else {
          this.SendFormData();
        }
      }
    },
    addClass(el, className) {
      let classes = el.className ? el.className.split(' ') : [];
      if (classes.indexOf(className) === -1) {
        classes.push(className);
        // eslint-disable-next-line no-param-reassign
        el.className = classes.join(' ');
      }
    },
    hasClass(el, className) {
      let classes = el.className ? el.className.split(' ') : [];
      return classes.indexOf(className) > -1;
    },
    removeClass(el, className) {
      let classes = el.className ? el.className.split(' ') : [];
      const ret = [];
      for (let i = 0; i < classes.length; i++) {
        let e = classes[i];
        if (e !== className) {
          ret.push(e);
        }
      }
      // eslint-disable-next-line no-param-reassign
      el.className = ret.join(' ');
    },
    GPFieldValidate(e) {
      const el = e.target ? e.target : e;
      if (!(el && el.getAttribute('validation'))) { // && el.is(':visible')
        return 0;
      }

      let validation = el.getAttribute('validation');
      validation = validation ? validation.toLowerCase() : '';

      this.removeClass(el, 'GPformError');
      el.setAttribute('data-error-msg', '');

      let errorMessage = '';

      if (validation.indexOf('required') > -1
        && (el.value === '')) { // || (el.is(':checkbox') && el.is(':checked')))) {
        errorMessage = `${el.getAttribute('name')} - Required field missing`;
        if (this.findingSubmitErrors) {
          this.analyticsService.trackMarketingFormPost({
            event: 'error',
            action: 'missing field',
            label: `${this.config.formBehavior} : ${errorMessage}`,
          });
        }
      }


      if (validation.indexOf('zip') > -1 &&
        (el.value.length < 5 || !/^\d{5}(?:[-\s]\d{4})?$/.test(el.value))) {
        // checks if zip is at least 5 digits, no
        errorMessage = 'Zip Code is not valid';
        if (this.findingSubmitErrors) {
          this.analyticsService.trackMarketingFormPost({
            event: 'error',
            action: 'invalid zipcode',
            label: `${this.config.formBehavior} : ${errorMessage}`,
          });
        }
        this.zipFieldEdited = this.zipFieldEdited ? this.zipFieldEdited : !this.zipFieldEdited;
      }

      if (validation.indexOf('phone') > -1) {
        el.setAttribute('maxlength', '10');
        el.value = el.value.replace(/[^0-9.]/g, '');
        if (el.value.length > 10) {
          errorMessage = 'Phone is not valid';
          if (this.findingSubmitErrors) {
            this.analyticsService.trackMarketingFormPost({
              event: 'error',
              action: 'invalid phone',
              label: `${this.config.formBehavior} : ${errorMessage}`,
            });
          }
        }
      }

      if (validation.indexOf('email') > -1 && el.value !== '') {
        if (!this.GPisValidEmailAddress(el.value)) {
          errorMessage = 'Email isn\'t valid.';
          if (this.findingSubmitErrors) {
            this.analyticsService.trackMarketingFormPost({
              event: 'error',
              action: 'invalid email',
              label: `${this.config.formBehavior} : ${errorMessage}`,
            });
          }
        }
        this.emailFieldEdited = this.emailFieldEdited ? this.emailFieldEdited : !this.emailFieldEdited;
      }

      if (errorMessage) {
        this.addClass(el, 'GPformError');
        el.setAttribute('data-error-msg', errorMessage);
      }

      this.ShowErrors();

      if (errorMessage) {
        return 1;
      }
      return 0;
    },
    SendFormData() {
      const formData = {};
      formData.existing_opt = this.existingOpt;
      const fields = this.$el.querySelectorAll('input, select, textarea');
      for (let i = 0; i < fields.length; i++) {
        let element = fields[i];
        let fieldName = element.getAttribute('name');
        fieldName = fieldName ? fieldName.toLowerCase() : '';
        if (fieldName && element.value && element.type.toLowerCase() !== 'submit') {
          formData[fieldName] = element.value;
          if (fieldName === 'email') {
            const email = formData[fieldName];
            // The ":" prefix is a way to let the user bypass the BriteVerify call
            if (email[0] === ':') {
              formData[fieldName] = email.substr(1);
            }
          }
        }
      }
      if (!formData.brands) {
        formData.brands = this.globals.siteId.toLowerCase();
      }
      if (!formData.referring_url) {
        formData.referring_url = window.location.href;
      }
      if (!formData.int_source && this.config.intSource) {
        formData.int_source = this.config.intSource;
      }
      this.GetAuthToken((success) => {
        if (success) {
          // eslint-disable-next-line prefer-template
          axios.post(this.config.urlPrefix + this.config.submitUrl, this.ObjectToQueryString(formData), { headers: { 'Content-Type': 'application/x-www-form-urlencoded', Authorization: `bearer ${this.config.access_token}` } })
            .then(this.handleSendFormDataResponse)
            .catch(this.handleSendFormDataError);
        }
      });
    },
    GetAuthToken(callback) {
      const self = this;
      if (this.config.access_token) {
        if (callback) {
          callback.call(self, true);
        }
      } else {
        // eslint-disable-next-line prefer-template
        axios.post(this.config.urlPrefix + this.config.authUrl)
          .then((response) => {
            if (response && response.data && response.data.access_token) {
              this.config.access_token = response.data.access_token;
              if (callback) {
                callback.call(self, true);
              }
            } else {
              this.handleSendFormDataError.call('The server is unable to accept this form post at this time.');
            }
          })
          .catch(this.handleSendFormDataError);

        // https://localhost:9002/authorizationserver/oauth/token?client_id=mobile_android&client_secret=secret&grant_type=client_credentials
        /*
          {
              "access_token": "e13b0ab7-b93a-4fa0-b38d-b1c05e2b04aa",
              "token_type": "bearer",
              "expires_in": 42074,
              "scope": "basic openid"
          }
        */
      }
    },
    handleSendFormDataError(errorMessage) {
      let errorMessageInternal = 'There was a problem submitting the form. Please try again.';
      this.analyticsService.trackMarketingFormPost({
        event: 'error',
        action: 'view',
        label: `${this.config.formBehavior} : ${errorMessageInternal}`,
      });
      if (errorMessage) {
        errorMessageInternal = errorMessage;
      }

      this.EnableSubmit();
      if (errorMessageInternal) {
        this.emailField.setAttribute('data-error-msg', errorMessageInternal);
        this.ShowErrors();
      }
    },
    handleSendFormDataResponse(response) {
      const data = JSON.parse(response.data);
      if (!data.results.success) {
        if (data.results.error.length > 0) {
          this.handleSendFormDataError(data.results.error); // .join('</br>')
        } else {
          this.handleSendFormDataError();
        }
        return;
      }

      let cpUserId = '';
      if (data.results.cpuserid) {
        cpUserId = data.results.cpuserid;
        // set cookie to expire in 10 years (HL)
        let CookieDate = new Date();
        CookieDate.setFullYear(CookieDate.getFullYear() + 10);
        document.cookie = `cpUserId=${cpUserId};expires=${CookieDate.toUTCString()}; path=/`;
      }

      let analyticsCallbackHandled = false;
      const self = this;
      const analyticsCallback = function() {
        // gets called for each GTM tag
        if (analyticsCallbackHandled) {
          return;
        }
        analyticsCallbackHandled = true;

        self.EnableSubmit();
        if (self.config.targetType === 'url') {
          document.location = self.existingOpt ? (self.config.galleryTarget + cpUserId) : self.config.thanksTarget;
        } else if (self.config.targetType === 'element') {
          if (self.$el.querySelector('.campaignOptForm')) {
            self.$el.querySelector('.campaignOptForm').style.margin = '5rem';
          }
          self.$el.querySelector(self.config.thanksTarget).style.display = 'block';
          self.$el.querySelector('.FormView').style.display = 'none';
        }
      };
      switch (this.config.formBehavior) {
        case 'optin-popup': this.analyticsService.trackMarketingFormPost({
          event: 'promotionClick',
          action: 'submit',
          label: this.existingOpt ? 'existingopt' : 'newopt',
          ecommerce: {
            promoClick: {
              promotions: [{
                creative: this.config.formBehavior,
                name: 'form|optin popup',
                position: document.title,
                id: this.config.opt_Attribution_Version,
              }],
            },
          },
          eventCallback: analyticsCallback,
        });
          break;
        case 'optin':
        case 'optin-sticky': {
          this.analyticsService.trackMarketingFormPost({
            event: 'promotionClick',
            action: 'submit',
            label: this.existingOpt ? 'existingopt' : 'newopt',
            ecommerce: {
              promoClick: {
                promotions: [{
                  creative: this.config.formBehavior,
                  name: 'form|optin',
                  position: document.title,
                  id: this.config.opt_Attribution_Version,
                }],
              },
            },
            eventCallback: analyticsCallback,
          });
          break;
        } case 'optout': {
          this.analyticsService.trackMarketingFormPost({
            eventCategory: 'optoutform',
            eventAction: 'submit',
            eventLabel: 'optout',
            event: 'fireTags',
            cpUserId: cpUserId,
            eventCallback: analyticsCallback,
          });
          break;
        } default: {
          this.analyticsService.trackMarketingFormPost({
            eventCategory: 'gpform',
            eventAction: 'submit',
            eventLabel: 'passthru',
            event: 'fireTags',
            cpUserId: cpUserId,
            eventCallback: analyticsCallback,
          });
          break;
        }
      }
    },
    ObjectToQueryString(object) {
      if (object) {
        return Object.keys(object).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
      }
      return '';
    },
    GetUserOptInStatus(callback) {
      const email = this.emailField.value;
      if (email.length > 0 && email[0] === ':') {
        this.email = email.substr(1);
      }
      this.GetAuthToken((success) => {
        if (success) {
          // eslint-disable-next-line prefer-template
          axios.post(this.config.urlPrefix + this.config.getoptinstatusUrl, this.ObjectToQueryString({
            email: email,
            brands: this.globals.siteId,
          }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded', Authorization: `bearer ${this.config.access_token}` } })
            .then((response) => {
              if (callback) {
                const resp = JSON.parse(response.data);
                // eslint-disable-next-line eqeqeq
                if (resp.results && resp.results.success) { resp.results.success = (resp.results.success == 'true'); }
                callback.call(this, resp);
              }
            })
            .catch(() => {
              if (callback) {
                callback.call(this, { results: { success: false } });
              }
            });
        }
      });
    },
    ValidateBriteVerify(callback) {
      if (this.emailField.value[0] === ':') {
        callback.call(this, true);
        return;
      }
      const capitalize = (tempSiteID) => {
        if (typeof tempSiteID !== 'string') return '';
        return tempSiteID.charAt(0).toUpperCase() + tempSiteID.slice(1);
      };
      const newSiteID = capitalize(this.globals.siteId);
      const request = {
        remoteName: `${newSiteID}-BV`,
        remoteUrl: `/emails.json?address=${this.emailField.value}&apikey={$remote_access_token}`,
        remoteHeaders: ['Content-Type:application/json'],
        postData: '',
      };
      this.GetAuthToken((success) => {
        if (success) {
          const options = {
            headers: {
              Authorization: `bearer ${this.config.access_token}`,
              'Content-Type': 'application/json',
            },
          };
          axios.post(
            this.API_URL,
            request,
            options,
          ).then((data) => {
            const response = JSON.parse(JSON.parse(data.request.response));
            if (
              response &&
              response.status !== 'invalid' &&
              response.status !== 'unknown' &&
              response.status !== 'accept_all' &&
              response.disposable !== 'true'
            ) {
              callback.call(this, true);
            } else {
              callback.call(this, false);
            }
          }).catch(() => {
            callback.call(this, true);
          });
        }
      });
    },
    ShowErrors() {
      const out = [];
      const errors = this.$el.querySelectorAll('[data-error-msg]');
      for (let i = 0; i < errors.length; i++) {
        let el = errors[i];
        if (el.hasAttribute('data-error-msg')) {
          out.push(el.getAttribute('data-error-msg'));
        }
      }
      let result = [];
      for (let i = 0; i < out.length; i++) {
        if (out[i].length) { result.push(out[i]); }
      }
      this.gpFormErrorMsg.innerHTML = result.join('<br/>');
    },
    showPopup() {
      this.popupWrap.style.display = 'block';
      setTimeout(() => {
        this.popupWrap.style.opacity = 1;
        this.popupBox.style.transform = 'translate(-50%, -50%) scale(1)';
      }, 10);
      this.analyticsService.trackMarketingFormPost({
        event: 'promotionView',
        action: 'view',
        label: 'impression',
        ecommerce: {
          promoView: {
            promotions: [{
              creative: this.config.formBehavior,
              name: 'form|optin popup',
              position: document.title,
              id: this.config.opt_Attribution_Version,
            }],
          },
        },
      });
      // Save data to sessionStorage
      sessionStorage.setItem('popup', 'true');
      this.eraseCookie(this.globals.POPUP_TIME_FLAG);
    },
    isFilteredPage() {
      const excludedPages = [
        '/save',
        '/savings',
        '/thanks',
        '/gallery',
        '/cart',
        '/checkout',
        '/covid',
        '/opt-out',
        '/giants-take-action',
        '/give-with-angel-soft',
        '/cooking-at-home',
        '/meet-the-chefs',
        '/cajun-fried-rice',
        '/chocolate-chip-cookies',
        '/coconut-curry-chicken',
        '/easy-orecchiette-pasta',
        // 'angelsoft.com',
        // 'quiltednorthern.com',
        '/pet',
        '/pet/3-layer-paper-towels',
        '/pet/cleaning-cloths',
        '/pet/wet-cleaning-wipes',
        '/brawny-whoops-pet',
      ];

      const includePages = [
        '/orderConfirmation',
      ];
      for (let i = 0; i < includePages.length; i++) {
        if (location.href.indexOf(includePages[i]) > 0) {
          return false;
        }
      }
      for (let i = 0; i < excludedPages.length; i++) {
        if (excludedPages[i][0] !== '/') {
          if (location.host.indexOf(excludedPages[i]) >= 0 && location.pathname === '/') {
            return true;
          }
        } else if (location.href.indexOf(excludedPages[i]) >= 0) {
          return true;
        }
      }

      return false;
    },

    hidePopup() {
      setTimeout(() => { this.popupWrap.style.display = 'none'; }, 500);
      this.popupWrap.style.transition = 'all ease .5s';
      this.popupBox.style.transform = 'translate(-50%, -50%) scale(0.5)';
      this.popupWrap.style.opacity = 0;
      const successfulSubmit = this.$el.querySelector('.ThanksView').style.display === 'block';
      const label = successfulSubmit ? 'ClosePopUp-Success' : 'ClosePopUp';

      this.analyticsService.trackMarketingFormPost({
        event: 'promotionClick',
        action: 'engagement',
        label: label,
        ecommerce: {
          promoClick: {
            promotions: [{
              creative: this.config.formBehavior,
              name: 'form|optin popup',
              position: document.title,
              id: this.config.opt_Attribution_Version,
            }],
          },
        },
      });
    },

    radioSelection(e) {
      const el = e.target ? e.target : e;
      const sibEls = el.parentElement.childNodes;
      for (let i = 0; i < sibEls.length; i++) {
        if (sibEls[i].type === 'hidden') {
          sibEls[i].value = el.value;
          this.GPFieldValidate(sibEls[i]);
          break;
        }
      }
    },

    emailInputClick() {
      let pushData = false;
      if (!this.optinEmailClicked || !this.popupEmailClicked) {
        let name = '';
        if (this.config.formBehavior.toLowerCase() === 'optin-popup' && !this.popupEmailClicked) {
          name = 'form|optin popup';
          this.popupEmailClicked = true;
          pushData = true;
        } else if (this.config.formBehavior.toLowerCase() === 'optin' && !this.optinEmailClicked) {
          name = 'form|optin';
          this.optinEmailClicked = true;
          pushData = true;
        } else {
          pushData = false;
        }

        if (pushData) {
          this.analyticsService.trackMarketingFormPost({
            event: 'promotionClick',
            action: 'engagement',
            label: 'email',
            ecommerce: {
              promoClick: {
                promotions: [{
                  creative: this.config.formBehavior,
                  name: name,
                  position: document.title,
                  id: this.config.opt_Attribution_Version,
                }],
              },
            },
          });
        }
      }
    },

    zipInputClick() {
      let pushData = false;
      if (!this.optinZipClicked || !this.popupZipClicked) {
        let name = '';
        if (this.config.formBehavior.toLowerCase() === 'optin-popup' && !this.popupZipClicked) {
          name = 'form|optin popup';
          this.popupZipClicked = true;
          pushData = true;
        } else if (this.config.formBehavior.toLowerCase() === 'optin' && !this.optinZipClicked) {
          name = 'form|optin';
          this.optinZipClicked = true;
          pushData = true;
        } else {
          pushData = false;
        }

        if (pushData) {
          this.analyticsService.trackMarketingFormPost({
            event: 'promotionClick',
            action: 'engagement',
            label: 'zipcode',
            ecommerce: {
              promoClick: {
                promotions: [{
                  creative: this.config.formBehavior,
                  name: name,
                  position: document.title,
                  id: this.config.opt_Attribution_Version,
                }],
              },
            },
          });
        }
      }
    },
    checkFormPos() {
      let elementBoundingBox = this.$el.getBoundingClientRect();
      let elementTopY = elementBoundingBox.top;
      let elementBottomY = elementBoundingBox.top + elementBoundingBox.height;
      let inview = elementTopY >= 0 && elementBottomY <= Math.min(document.documentElement.clientHeight, window.innerHeight || 0);

      if (inview) {
        this.analyticsService.trackMarketingFormPost({
          event: 'promotionView',
          action: 'view',
          label: 'impression',
          ecommerce: {
            promoView: {
              promotions: [{
                creative: this.config.formBehavior,
                name: 'form|optin',
                position: document.title,
                id: this.config.opt_Attribution_Version,
              }],
            },
          },
        });
        clearInterval(this.intervalID);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/common/vx-marketing-form/vx-marketing-form.js